import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApiSchemaAppointmentByMonth } from "../../../models/api/appointment";
import { UtilityDate } from "../../../utils/dateUtils";
import { endOfMonth, startOfMonth } from "date-fns";

interface AppointmentCalendarState {
  selectedDate: string;
  monthStart: string;
  monthEnd: string;
  data: ApiSchemaAppointmentByMonth[] | undefined;
  filterNurse: string;
  filterPatient: string;
  isLoading: boolean;
  searchKey: string;
}

const initialState: AppointmentCalendarState = {
  selectedDate: UtilityDate.ToIsoUtcDateTime(new Date()),
  monthStart: startOfMonth(new Date()).toISOString(),
  monthEnd: endOfMonth(new Date()).toISOString(),
  data: undefined,
  filterNurse: "",
  filterPatient: "",
  isLoading: false,
  searchKey: "",
};

export const sliceAppointmentCalendar = createSlice({
  name: "appointmentCalendar",
  initialState,
  reducers: {
    setSelectedDate: (
      state: AppointmentCalendarState,
      action: PayloadAction<string>
    ) => {
      return {
        ...state,
        selectedDate: action.payload,
      };
    },

    setMonth: (
      state: AppointmentCalendarState,
      action: PayloadAction<{ start: string; end: string }>
    ) => {
      return {
        ...state,
        monthStart: action.payload.start,
        monthEnd: action.payload.end,
      };
    },

    setData: (
      state: AppointmentCalendarState,
      action: PayloadAction<ApiSchemaAppointmentByMonth[]>
    ) => ({
      ...state,
      data: action?.payload,
    }),

    setFilterNurse: (
      state: AppointmentCalendarState,
      action: PayloadAction<string>
    ) => ({
      ...state,
      filterNurse: action.payload,
    }),

    setFilterPatient: (
      state: AppointmentCalendarState,
      action: PayloadAction<string>
    ) => ({
      ...state,
      filterPatient: action.payload,
    }),

    setSearchKey: (
      state: AppointmentCalendarState,
      action: PayloadAction<string>
    ) => ({
      ...state,
      searchKey: action.payload,
    }),

    setIsLoading: (
      state: AppointmentCalendarState,
      action: PayloadAction<boolean>
    ) => ({
      ...state,
      isLoading: action.payload,
    }),
  },
});

export const appointmentCalendarActions = sliceAppointmentCalendar.actions;

export const ReducerAppointmentCalendar = sliceAppointmentCalendar.reducer;
export const ActionAppointmentCalendar = sliceAppointmentCalendar.actions;
